import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperatorService } from '../services/operator.service';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/internal/operators';
import { Subscription } from 'rxjs';
import { Address } from '../../account/models/Address';
import { OperatorDetails } from '../models/OperatorDetails';
import { CountyDTO } from '../../shared/models/CountyDTO';
import { AddressService } from '../../shared/services/address.service';
import { CityDTO } from '../../shared/models/CityDTO';
import { InternalDocument } from '../../../shared/model/internal-document';
import { DocumentService } from '../../../shared/service/document.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-company-data-operator',
  templateUrl: './identification-data-operator.component.html',
  styleUrls: ['./identification-data-operator.component.scss']
})
export class IdentificationDataOperatorComponent implements OnInit, OnDestroy {

  public operatorForm: FormGroup;
  public operatorDetails: any;
  public operatorId: number;
  public operatorDetailsSub: any;
  public isSameAddress = false;
  public editable = true;
  public cuiEditable = true;
  public invitedUser = true;
  private companyId: number;
  private subscriptions: Subscription[] = [];
  public adminDocuments: InternalDocument[] = [];
  public invitedDocument: InternalDocument;
  public counties: CountyDTO[] = [];
  public cities: CityDTO[] = [];
  public citiesCorrespondence: CityDTO[] = [];
  public validatedAndAdminRoleAssigned: boolean = false;
  public isFormSubmitAttempt: boolean = false;
  public settings = {

    columns: {
      img: {
        title: 'Image',
        type: 'html',
      },
      file_name: {
        title: 'File Name'
      },
      url: {
        title: 'Url',
      },
    },
  };

  constructor(
    private formBuilder: FormBuilder,
    public documentService: DocumentService,
    private operatorService: OperatorService,
    private addressService: AddressService,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
  ) {
    this.createOperatorForm();
    this.createOperatorFormListeners();
  }

  createOperatorForm(): void {
    this.operatorForm = this.formBuilder.group({
      code: [''],
      number: [''],
      name: ['', [Validators.required]],
      phoneNumber: [''],
      mobileNumber: [''],
      fax: [''],
      cui: ['', [Validators.required]],
      onrcRegistrationNumber: ['', [Validators.required]],
      email: [''],
      legalForm: ['', [Validators.required]],
      licenseGas: ['', [Validators.required]],
      licenseElectricity: ['', [Validators.required]],
      // address
      county: ['', [Validators.required]],
      city: ['', [Validators.required]],
      streetName: ['', [Validators.required]],
      streetNumber: ['', [Validators.required]],
      block: [''],
      apartment: [''],
      floor: [''],
      extendedAddress: [''],
      postalCode: [''],
      // correspondenceAddress
      sameAddress: [''],
      correspondenceCounty: ['', [Validators.required]],
      correspondenceCity: ['', [Validators.required]],
      correspondenceStreetName: ['', [Validators.required]],
      correspondenceStreetNumber: ['', [Validators.required]],
      correspondenceBlock: [''],
      correspondenceFloor: [''],
      correspondenceApartment: [''],
      correspondenceExtendedAddress: [''],
      correspondencePostalCode: [''],
      // person
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      cnp: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      position: ['', [Validators.required]],
    });
  }

  createOperatorFormListeners(): void {
    this.subscriptions.push(
      this.operatorForm.get('licenseGas').valueChanges.subscribe(value => {
        if (value) {
          this.operatorForm.get('licenseElectricity').clearValidators();
        } else {
          this.operatorForm.get('licenseElectricity').setValidators([Validators.required]);
        }
        this.operatorForm.controls['licenseElectricity'].updateValueAndValidity({ onlySelf: true, emitEvent: false })
      }
      ));
    this.subscriptions.push(
      this.operatorForm.get('licenseElectricity').valueChanges.subscribe(value => {
        if (value) {
          this.operatorForm.get('licenseGas').clearValidators();
        } else {
          this.operatorForm.get('licenseGas').setValidators([Validators.required]);
        }
        this.operatorForm.controls['licenseGas'].updateValueAndValidity({ onlySelf: true, emitEvent: false })
      }
      ));
    this.subscriptions.push(
      this.operatorForm.get('county').valueChanges.subscribe(value => this.updateCorrespondenceCounty(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('city').valueChanges.subscribe(value => this.updateCorrespondenceCity(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('streetName').valueChanges.subscribe(value => this.updateCorrespondenceStreetName(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('streetNumber').valueChanges.subscribe(value => this.updateCorrespondenceStreetNumber(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('block').valueChanges.subscribe(value => this.updateCorrespondenceBlock(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('apartment').valueChanges.subscribe(value => this.updateCorrespondenceApartment(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('floor').valueChanges.subscribe(value => this.updateCorrespondenceFloor(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('extendedAddress').valueChanges.subscribe(value => this.updateCorrespondenceExtendedAddress(value))
    );
    this.subscriptions.push(
      this.operatorForm.get('postalCode').valueChanges.subscribe(value => this.updateCorrespondencePostalCode(value))
    );
  }

  ngOnInit(): void {
    this.addressService.getCounties().subscribe(data => this.counties = data);
    this.operatorDetailsSub = this.operatorService.getOperatorDetails()
      .pipe(
        map(value => {
          if (value) {
            return value;
          }
          return {
            companyDTO: {
              code: '',
              number: '',
              name: '',
              phoneNumber: '',
              mobileNumber: '',
              fax: '',
              email: '',
              legalForm: '',
              addressDTO: {
                county: '',
                city: '',
                streetName: '',
                streetNumber: '',
                block: '',
                floor: '',
                apartment: '',
                extendedAddress: '',
                postalCode: ''
              },
              correspondenceAddressDTO: {
                county: '',
                city: '',
                streetName: '',
                streetNumber: '',
                block: '',
                floor: '',
                apartment: '',
                extendedAddress: '',
                postalCode: ''
              }
            },
            firstName: '',
            lastName: '',
            cnp: '',
            position: '',
            editable: true,
            cuiEditable: true,
            invited: false,
            validatedAndAdminRoleAssigned: false,
            licenseGas: '',
            licenseElectricity: ''
          };
        })
      )
      .subscribe((operatorDetails: OperatorDetails) => this.initializeFormFields(operatorDetails));
  }

  initializeFormFields(operatorDetails: OperatorDetails): void {
    if (operatorDetails) {
      const {
        companyDTO,
        firstName,
        lastName,
        cnp,
        position,
        licenseGas,
        licenseElectricity,
        documents,
        validatedAndAdminRoleAssigned
      }
        = operatorDetails;

      this.operatorDetails = {
        ...companyDTO.addressDTO,
        ...companyDTO,
        firstName,
        lastName,
        cnp,
        position,
        licenseGas,
        licenseElectricity,
        validatedAndAdminRoleAssigned
      };
      this.companyId = operatorDetails.companyDTO.id;
      this.operatorId = operatorDetails.id;
      this.invitedUser = operatorDetails.invited;
      this.validatedAndAdminRoleAssigned = operatorDetails.validatedAndAdminRoleAssigned;
      if (this.invitedUser) {
        this.invitedDocument = documents != null && documents.length > 0 ? documents[0] : null;
      } else {
        this.adminDocuments = documents != null ? documents : [];
      }

      Object.keys(this.operatorForm.controls).forEach(
        key => {
          if (this.operatorDetails[key]) {
            this.operatorForm.controls[key].setValue(this.operatorDetails[key]);
          }
        }
      );

      this.operatorForm.patchValue({
        correspondenceCounty: companyDTO.correspondenceAddressDTO.county,
        correspondenceCity: companyDTO.correspondenceAddressDTO.city,
        correspondenceStreetName: companyDTO.correspondenceAddressDTO.streetName,
        correspondenceStreetNumber: companyDTO.correspondenceAddressDTO.streetNumber,
        correspondenceBlock: companyDTO.correspondenceAddressDTO.block,
        correspondenceFloor: companyDTO.correspondenceAddressDTO.floor,
        correspondenceApartment: companyDTO.correspondenceAddressDTO.apartment,
        correspondenceExtendedAddress: companyDTO.correspondenceAddressDTO.extendedAddress,
        correspondencePostalCode: companyDTO.correspondenceAddressDTO.postalCode
      });
      this.cities = [];
      this.citiesCorrespondence = [];
      this.addressService.getCities(this.operatorForm.get('county').value)
        .subscribe(data => this.cities = data);
      this.addressService.getCities(this.operatorForm.get('correspondenceCounty').value)
        .subscribe(data => this.citiesCorrespondence = data);
      this.editable = !!operatorDetails.editable;
      this.cuiEditable = !!operatorDetails.cuiEditable;
      if (!operatorDetails.editable) {
        this.operatorForm.disable();
      }
      if (!operatorDetails.cuiEditable) {
        const control = this.operatorForm.get('cui');
        if (control) {
          control.disable();
        }
      }
      if (!!this.invitedUser) {
        for (const [key, control] of Object.entries(this.operatorForm.controls)) {
          if (key === 'firstName' || key === 'lastName' || key === 'cnp' || key === 'position') {
            control.enable();
          }
        }
      }
      if (operatorDetails.validatedAndAdminRoleAssigned) {
        const licenseGasControl = this.operatorForm.get('licenseGas');
        if (licenseGasControl) {
          licenseGasControl.disable();
        }
        const licenseElectricityControl = this.operatorForm.get('licenseElectricity');
        if (licenseElectricityControl) {
          licenseElectricityControl.disable();
        }
      }
    }
  }

  toggleSameAddress(): void {
    this.isSameAddress = !this.isSameAddress;
    if (this.isSameAddress) {
      this.citiesCorrespondence = [];
      this.addressService.getCities(this.operatorForm.get('county').value)
        .subscribe((citiesCorrespondence: CityDTO[]) => {
          this.citiesCorrespondence = citiesCorrespondence;
        });
      const formData = this.operatorForm.value;
      this.operatorForm.patchValue({
        correspondenceCounty: formData.county,
        correspondenceCity: formData.city,
        correspondenceStreetName: formData.streetName,
        correspondenceStreetNumber: formData.streetNumber,
        correspondenceBlock: formData.block,
        correspondenceFloor: formData.floor,
        correspondenceApartment: formData.apartment,
        correspondencePostalCode: formData.postalCode,
      });
      this.operatorForm.controls.correspondenceStreetName.disable();
      this.operatorForm.controls.correspondenceStreetNumber.disable();
      this.operatorForm.controls.correspondenceApartment.disable();
      this.operatorForm.controls.correspondenceBlock.disable();
      this.operatorForm.controls.correspondenceFloor.disable();
      this.operatorForm.controls.correspondencePostalCode.disable();
      this.operatorForm.controls.correspondenceCounty.disable();
      this.operatorForm.controls.correspondenceCity.disable();
    } else {
      this.operatorForm.controls.correspondenceStreetName.enable();
      this.operatorForm.controls.correspondenceStreetNumber.enable();
      this.operatorForm.controls.correspondenceApartment.enable();
      this.operatorForm.controls.correspondenceBlock.enable();
      this.operatorForm.controls.correspondenceFloor.enable();
      this.operatorForm.controls.correspondencePostalCode.enable();
      this.operatorForm.controls.correspondenceCounty.enable();
      this.operatorForm.controls.correspondenceCity.enable();
    }
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  onDisplayRequiredAdminDocuments(): any {
    return {
      'border-red': this.adminDocuments?.length === 0 && this.isFormSubmitAttempt,
    };
  }

  saveOperatorDetails(): void {
    this.isFormSubmitAttempt = true;
    if (!this.operatorForm.valid || (this.invitedUser && !this.invitedDocument) || (!this.invitedUser && this.adminDocuments?.length === 0)) {
      this.errorNotification('Nu toate campurile marcate cu steluta rosie au fost completate. Va rugam verificati');
      return;
    }
    if (this.operatorDetails) {
      const formData = this.operatorForm.getRawValue();

      const addressDTO: Address = {
        city: formData.city,
        extendedAddress: formData.extendedAddress,
        postalCode: formData.postalCode,
        county: formData.county,
        streetNumber: formData.streetNumber,
        streetName: formData.streetName,
        block: formData.block,
        floor: formData.floor,
        apartment: formData.apartment
      };

      const correspondenceAddressDTO: Address = this.isSameAddress ? addressDTO : {
        city: formData.correspondenceCity,
        extendedAddress: formData.correspondenceExtendedAddress,
        postalCode: formData.correspondencePostalCode,
        county: formData.correspondenceCounty,
        streetNumber: formData.correspondenceStreetNumber,
        streetName: formData.correspondenceStreetName,
        block: formData.correspondenceBlock,
        floor: formData.correspondenceFloor,
        apartment: formData.correspondenceApartment
      };

      const operatorDetails: OperatorDetails = {
        id: this.operatorId,
        companyDTO: {
          id: this.companyId,
          addressDTO,
          correspondenceAddressDTO,
          fax: formData.fax,
          name: formData.name,
          email: formData.email,
          legalForm: formData.legalForm,
          mobileNumber: formData.mobileNumber,
          phoneNumber: formData.phoneNumber,
          code: formData.cui,
          cui: formData.cui,
          onrcRegistrationNumber: formData.onrcRegistrationNumber
        },
        firstName: formData.firstName,
        lastName: formData.lastName,
        cnp: formData.cnp,
        position: formData.position,
        licenseGas: formData.licenseGas,
        licenseElectricity: formData.licenseElectricity,
        documents: this.invitedUser ? [this.invitedDocument] : this.adminDocuments,
        validatedAndAdminRoleAssigned: false
      };

      const operatorData: FormData = new FormData();
      operatorData.append('operatorDetails', JSON.stringify(operatorDetails));
      if (this.invitedUser) {
        if (this.invitedDocument && this.invitedDocument.file) {
          operatorData.append('documents', this.invitedDocument.file, this.invitedDocument.fileName);
        }
      } else if (this.adminDocuments) {
        for (const document of this.adminDocuments) {
          if (document.file) {
            operatorData.append('documents', document.file, document.fileName);
          }
        }
      }
      this.operatorService.updateOperatorDataDetails(operatorData).subscribe(
        operatorDet => {
          this.toastrService.success('Date personale actualizate cu success.');
          // this.reloadCurrentRoute();
          this.initializeFormFields(operatorDet);
        }
      );
    }
  }

  reloadCurrentRoute(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  updateCorrespondenceCounty(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceCounty.setValue(value);
    }
  }

  updateCorrespondenceCity(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceCity.setValue(value);
    }
  }

  updateCorrespondenceStreetName(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceStreetName.setValue(value);
    }
  }

  updateCorrespondenceStreetNumber(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceStreetNumber.setValue(value);
    }
  }

  updateCorrespondenceBlock(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceBlock.setValue(value);
    }
  }

  updateCorrespondenceFloor(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceFloor.setValue(value);
    }
  }

  updateCorrespondenceApartment(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceApartment.setValue(value);
    }
  }

  updateCorrespondenceExtendedAddress(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondenceExtendedAddress.setValue(value);
    }
  }

  updateCorrespondencePostalCode(value: any): void {
    if (this.isSameAddress) {
      this.operatorForm.controls.correspondencePostalCode.setValue(value);
    }
  }

  upload(fileList: FileList): void {
    console.log('upload', fileList);
    if (this.editable || this.invitedUser) {
      if (fileList.length > 0) {
        if (this.invitedUser) {
          if (!this.documentNameExists(fileList.item(0).name)) {
            const document = {
              fileName: fileList.item(0).name,
              fileByteSize: fileList.item(0).size,
              fileType: fileList.item(0).type,
              file: fileList.item(0)
            };
            this.invitedDocument = document;
          }
        } else {
          for (let i = 0; i < fileList.length; i++) {
            if (!this.documentNameExists(fileList.item(i).name)) {
              const document = {
                fileName: fileList.item(i).name,
                fileByteSize: fileList.item(i).size,
                fileType: fileList.item(i).type,
                file: fileList.item(i)
              };
              this.adminDocuments.push(document);
            }
          }
        }
      }
    }
  }

  cancel(): void {
    history.back();
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
    if (this.operatorDetailsSub) {
      this.operatorDetailsSub.unsubscribe();
    }
  }

  onChangeCounty(): void {
    this.cities = [];
    if (this.isSameAddress) {
      this.citiesCorrespondence = [];
    }
    this.addressService.getCities(this.operatorForm.get('county').value).subscribe((cities: CityDTO[]) => {
      this.cities = cities;
      if (this.isSameAddress) {
        this.citiesCorrespondence = cities;
      }
    });
  }

  onChangeCountyCorrespondence(): void {
    this.citiesCorrespondence = [];
    this.addressService.getCities(this.operatorForm.get('correspondenceCounty').value)
      .subscribe((citiesCorrespondence: CityDTO[]) =>
        this.citiesCorrespondence = citiesCorrespondence);
  }

  deleteDocument(index?: number): void {
    if (this.invitedUser) {
      this.invitedDocument = null;
    } else if (this.adminDocuments) {
      this.adminDocuments.splice(index, 1);
    }
  }

  documentNameExists(fileName: string): boolean {
    if (this.invitedUser) {
      return this.invitedDocument ? this.invitedDocument.fileName === fileName : false;
    } else {
      return this.adminDocuments.some(function (el) {
        return el.fileName === fileName;
      });
    }
  }

  openInvitations(): void {
    this.router.navigate(['..', 'invitatii'], { relativeTo: this.route });
  }

  getCommitButtonTemplateName(): string {
    if (this.invitedUser) {
      return 'save';
    }
    if (this.editable && this.cuiEditable) {
      return 'send';
    }
    if (this.editable && !this.cuiEditable) {
      return 'save';
    }
    return 'pending';
  }

}
